import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { UniverseComponent } from 'src/domains/common/universes';
import { LogoWrapper } from './HeaderMainLogo.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const HeaderMainLogo = observer('HeaderMainLogo', (): JSX.Element | null => {
    const common = useCommon();
    const config = ConfigComponents.get(common).config;

    return (
        <UniverseComponent>
            {(universeVersion): React.ReactElement => (
                <LogoWrapper>
                    <universeVersion.headerLink
                        to={{ name: 'homepage' }}
                        dataTest='LinkWrapper'
                        title={`${config.operatorFullName}`}
                    >
                        <universeVersion.headerLogo />
                    </universeVersion.headerLink>
                </LogoWrapper>
            )}
        </UniverseComponent>
    );
});
